import requestApi from "@/utils/requestApi";
import shopInfo from "../components/shop/index.vue";
import goodsInfo from "../components/goods/index.vue";
import upload from "../components/upload/index.vue";

export default {
  components: {
    shopInfo,
    goodsInfo,
    upload,
  },
  data() {
    return {
      detail: {
        skuList: [],
      },
      loading: null,
      texts: ["非常差", "差", "一般", "好", "非常好"],
      colors: ["#fe5301", "#fe5301", "#fe5301"],
      goodsId: "",
      orderId: "",
      commentId: "",
      skuList: [],
    };
  },
  async created() {
    this.$store.commit("app/setShowTitle", true);
    this.$store.commit("app/setSellerMenuVisible", false);
    const { orderId, goodsId, commentId } = this.$route.query;

    this.loading = this.$loading({
      lock: true,
    });

    this.goodsId = goodsId;
    this.orderId = orderId;
    this.commentId = commentId;
    let arg = {
      orderId,
    };
    let url = "sctrading/evaluate/selToEvaluateInfo";

    if (commentId) {
      arg = {
        orderId,
        goodsId,
      };

      url = "sctrading/evaluate/selToReplyEvaluateInfo";
    }

    const { code, msg, data: resData } = await requestApi.post(url, arg);

    this.loading && this.loading.close();

    if (code != "0") {
      this.$message.error(msg);
      return;
    }

    if (commentId) {
      resData.skuList.forEach((item) => {
        item.cmtBody = "";
        item.imgList = [];
      });
    } else {
      if (resData.skuList && resData.skuList[0] && resData.skuList[0].evaluateSkuData) {
        this.$router.push(`/comment/comment?orderId=${resData.orderId}`);
        return;
      }
      const skuListTem = resData.skuList.map((item) => {
        if (item.evaluateSkuData) {
          return {
            ...item,
            cmtBody: item.evaluateSkuData.cmtBody,
            imgList: item.evaluateSkuData.imgList || [],
          };
        }

        return {
          ...item,
          imgList: item.imgList ? item.imgList : [],
        };
      });
      resData.skuList = skuListTem;
    }
    this.detail = resData;

    console.log("this.detail", this.detail);
  },
  methods: {
    async submit() {
      const { detail, orderId, commentId } = this;
      const cmtBody = detail.skuList.filter((item) => !item.cmtBody || item.cmtBody.replace(/^\s+|\s+$/g, "") == "");
      if (cmtBody[0]) {
        this.$message.warning(`『${cmtBody[0].name}』请描述您使用产品的真实感受`);
        return;
      }

      this.loading = this.$loading({
        lock: true,
      });

      let apiUrl = "sctrading/evaluate/saveEvaluateInfo";
      let arg = {};

      if (commentId) {
        arg = {
          orderId,
          reqFormList: [
            {
              commentId: commentId,
              cmtBody: detail.skuList[0].cmtBody,
              imgList: detail.skuList[0].imgList,
            },
          ],
        };
        apiUrl = "sctrading/evaluate/saveEvaluateReplyInfo";
      } else {
        const reqFormList = detail.skuList.map((item) => ({
          goodsId: item.goodsId,
          sellerService: detail.sellerService,
          sellDelivery: detail.sellDelivery,
          logisticsExponent: detail.logisticsExponent,
          goodsExponent: item.goodsExponent,
          cmtBody: item.cmtBody,
          imgList: item.imgList,
        }));

        arg = {
          orderId: detail.orderId,
          reqFormList,
        };
      }

      const { code, msg, data: ResData } = await requestApi.post(apiUrl, arg);

      this.loading && this.loading.close();

      if (code != "0") {
        this.$message.error(msg);
        return;
      }

      let url = `/comment/result?orderId=${detail.orderId}`;
      const { finishMsg } = ResData;
      if (finishMsg) {
        url = `${url}&finishMsg=${finishMsg}`;
      }

      this.$router.push(url);
    },
    rateChange(val, index) {
      this.$set(this.detail.skuList[index], "goodsExponent", val);
    },
  },
};
